import React, { Fragment, useEffect, useState } from 'react';
import { useTranslate} from 'react-admin';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { Typography, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, Grid, Icon, IconButton, Alert } from '@mui/material';
import PageDividerText from 'src/components/customComponents/B2/PageDividerText';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function BillingFormEditDialogReservations(reservation) {
	const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [openDialogReservation, setOpenDialogReservation] = React.useState(false);
	const [openModalItems, setOpenModalItems] = useState(false);
	const [selectedItem, setSelectedItems] = useState(null);
	const translate = useTranslate()
	// Start Dialog Reservation
	const handleOpenDialogReservation = () => {
		setOpenDialogReservation(true);
	};
	const handleCloseDialogReservation = () => {
		setOpenDialogReservation(false);
	};
	// End Dialog Payment

	// Start Download payment file
	const FileDownloadButton = ({ file }) => {
		// Manejador para descargar el archivo
		const handleDownload = () => {
			const link = document.createElement('a');
			link.href = file.bucket_path; // URL del archivo
			link.download = file.file_name; // Nombre del archivo para la descarga
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		};

		return (
			<Button startIcon={<Icon>description</Icon>} variant="outlined" onClick={handleDownload}>
				Descargar {file.file_name}
			</Button>
		);
	};
	// End Download payment file

	const handleOpenItems = (item) => {
		setSelectedItems(item);
		setOpenModalItems(true);
	};

	const ItemsModal = ({ open, handleClose, item }) => {
		return (
			<Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg" className='generalDialogContainer'>
				<DialogTitle className='dialogTitle'>Detalle de item {item ? item.description : ""}</DialogTitle>
				<DialogContent className='dialogContent'>
					{item ? (
						<table className='tableInfo bordered'>
							<tr className='tableHead'>
								<th className='cell'>Descripción</th>
								<th className='cell'>Estado de pago</th>
								<th className='cell'>Localizador</th>
								<th className='cell'>Fecha de creación</th>
								<th className='cell'>Fecha de pago</th>
							</tr>
							<tr className='tableBody'>
								<td className='cell'>{item.description}</td>
								<td className='cell'>{item.payment_status}</td>
								<td className='cell'>{item.localizer}</td>
								<td className='cell'>{item.created_at === "No disponible" ? item.created_at : dayjs(item.created_at).format('DD/MM/YYYY')}</td>
								<td className='cell'>{item.payment_due_date === "No disponible" ? item.payment_due_date : dayjs(item.payment_due_date).format('DD/MM/YYYY')}</td>

							</tr>
						</table>
					) : (
						<Typography variant="body1">No hay información disponible.</Typography>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={() => {setOpenModalItems(false)}} color="primary" variant="outlined">
						Cerrar
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	return (
		<React.Fragment>
			<ItemsModal
				open={openModalItems}
				handleClose={() => setOpenModalItems(false)}
				item={selectedItem}
			/>
			<Button variant="text" startIcon={<Icon>visibility</Icon>} onClick={handleOpenDialogReservation}>
			{translate('ra.action.see_details')}
			</Button>
			<Dialog
				onClose={handleCloseDialogReservation}
				aria-labelledby="customized-dialog-title"
				open={openDialogReservation}
				maxWidth="xl"

			>
				<DialogTitle id="customized-dialog-title">
				{translate('ra.entity.reservation')} {reservation?.reservation?.number}
				</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={handleCloseDialogReservation}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
				<DialogContent dividers className='generalFormStyles'>
					<Grid container spacing={3} >
					{/* <Grid item xs={12} md={12} lg={12} xl={12} style={{marginBottom: 10}}>
								<Alert variant="outlined" severity="info">{translate('ra.message.billingform_reservation_warning')} </Alert>
								</Grid> */}
						<Grid item xs={12} md={4} lg={4} xl={3} >
							<TextField
								size='small'
								fullWidth
								label={translate('ra.field.number')}
								disabled={true}
								value={reservation?.reservation?.number || ''}
								className="textField"
							/>
						</Grid>
						<Grid item xs={12} md={4} lg={4} xl={3} >
							<TextField
								size='small'
								fullWidth
								label={translate('ra.field.status')}
								disabled={true}
								value={reservation?.reservation?.status || ''}
								className="textField"
							/>
						</Grid>
						{/* <Grid item xs={12} md={6} lg={6} xl={6} >
							<TextField
								size='small'
								fullWidth
								label={translate('ra.field.hash')}
								disabled={true}
								value={reservation?.reservation?.hash_reservation || ''}
								className="textField"
							/>
						</Grid> */}

						{/* Start Bloq Withhold Payment */}
						<Grid item xs={12} md={12} lg={12} xl={12} >
							<Grid container spacing={3}>
								<Grid item xs={12} md={12} lg={12} xl={12}>
									<PageDividerText content="Items" />
								</Grid>
								<Grid item xs={12} md={12} lg={12} xl={12}>
									<table className='tableInfo bordered'>
										<tr className='tableHead'>
											<td className='cell'>{translate('ra.entity.product')}</td>
											<td className='cell'>{translate('ra.field.status')}</td>
											<td className='cell'>{translate('ra.field.currency')}</td>
											<td className='cell'>{translate('ra.field.total_cost')}</td>
										</tr>
										{reservation.reservation.items.map((item, index) => (
											<tr className='tableBody'>
												<td className='cell smallText bold'>
													{item.product_type}
													<IconButton
														onClick={() => handleOpenItems(item)}
														size="small">
														<InfoOutlinedIcon fontSize="small" />
													</IconButton>
												</td>
												<td className='cell smallText'>{item.status}</td>
												<td className='cell smallText'>
													<span className='lineTop'>{translate('ra.field.reserve')}</span>
													<span className='lineBottom'>{translate('ra.field.payment')}</span>
												</td>
												<td className='cell smallText'>
													<span className='lineTop'>{item.item_prices.origin_currency} {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(item.item_prices.total_amount))}</span>
													<span className='lineBottom'>{item.item_destination_prices.destination_currency} {item.item_destination_prices.total_amount}</span>
												</td>
											</tr>
										))}
									</table>

								</Grid>
							</Grid>
						</Grid>
						{/* End Bloq Withhold Payment */}
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button autoFocus variant="outlined" onClick={handleCloseDialogReservation}>
					{translate('ra.action.close')}
					</Button>
				</DialogActions>
			</Dialog>
		</React.Fragment>
	)
}
export default BillingFormEditDialogReservations